import React from "react";
import useDataContext from "../context/useDataContext";
import useCore from "../methods/core/useCore";

const TourNoPosts = () => {
    const { resetSelected } = useCore();
    const { globalData } = useDataContext();

    return (
        <>
            {globalData.tour_no_result ? (
                <div className="eight29-tour-no-results">
                    <div className="eight29-tour-no-results__top">
                        {globalData.tour_no_result.image && (
                            <figure className="eight29-tour-no-results__img">
                                <img
                                    src={globalData.tour_no_result.image.src[0]}
                                    width={
                                        globalData.tour_no_result.image.src[1]
                                    }
                                    height={
                                        globalData.tour_no_result.image.src[2]
                                    }
                                    srcSet={
                                        globalData.tour_no_result.image.srcset
                                    }
                                    alt={globalData.tour_no_result.image.alt}
                                ></img>
                            </figure>
                        )}
                        {globalData.tour_no_result.heading && (
                            <h2
                                className="eight29-tour-no-results__heading"
                                dangerouslySetInnerHTML={{
                                    __html: globalData.tour_no_result.heading,
                                }}
                            />
                        )}
                        {globalData.tour_no_result.description && (
                            <div
                                className="eight29-tour-no-results__description"
                                dangerouslySetInnerHTML={{
                                    __html: globalData.tour_no_result
                                        .description,
                                }}
                            />
                        )}
                    </div>
                    {globalData.tour_no_result.banner && (
                        <div className="eight29-tour-no-results__banner">
                            {globalData.tour_no_result.banner.heading && (
                                <h3
                                    className="eight29-tour-no-results__banner-heading"
                                    dangerouslySetInnerHTML={{
                                        __html: globalData.tour_no_result.banner
                                            .heading,
                                    }}
                                />
                            )}
                            {globalData.tour_no_result.banner.link && (
                                <a
                                    href={
                                        globalData.tour_no_result.banner.link
                                            .url
                                    }
                                    className="eight29-tour-no-results__banner-link c-btn c-btn-primary"
                                    target={
                                        globalData.tour_no_result.banner.link
                                            .target
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: globalData.tour_no_result.banner
                                            .link.title,
                                    }}
                                />
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <div className="no-results">
                    Sorry, no results.
                    <div className="c-btn-wrapper">
                        <button
                            className="c-btn c-btn-secondary c-btn-color-normal"
                            onClick={() => {
                                resetSelected();
                            }}
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default TourNoPosts;
